export const delegationsReducer = (state = {loading: false, resultdelegation: null, delegations: [], delegation: null, total: 0} , action) => {
    switch (action.type) {
        case 'DELEGATION_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                delegations: action.payload.delegations || [],
                total: action.payload.total || 0
            }
        case 'DELEGATION_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                resultdelegation: action.payload.message,
                delegation: action.payload.delegation,
                delegations: [...state.delegations, action.payload.delegation],
            }
        case 'DELEGATION_EDIT_SUCCESS':
            if(action.payload.delegation){
                return {
                    ...state,
                    loading: false,
                    resultdelegation: action.payload.message,
                    delegation: action.payload.delegation,
                    delegations: state.delegations.map(delegation => delegation._id === action.payload.delegation._id ? action.payload.delegation : delegation),
                }
            }else{
                return {
                    ...state,
                    loading: false,
                    resultdelegation: action.payload.message || action.payload
                }
            }
        case 'DELEGATION_RESET_RESULT':
            return {
                ...state,
                resultdelegation: null
            }
        case 'DELEGATION_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'DELEGATION_ERROR':
            return {
                ...state,
                loading: false,
                resultdelegation: action.payload
            }
        default:
            return state
    }
}